import actionTypes from 'src/js/modules/templates/constants/action-types';

const createSite = ({ name, templateSlug, locale, properties, settings }) => ({
  type: actionTypes.CREATE_SITE,
  payload: {
    name,
    templateSlug,
    locale,
    properties,
    settings,
  },
});

export default createSite;
